"use client";

import { parseColorTextToJSX } from "@/utils/utils";

const HowServiceWork = ({ data, title }) => {
  const bgColors = [
    "bg-[#658BFF]",
    "bg-[#1A2A4F]",
    "bg-[#016B61]",
    "bg-[#F59E0B]",
    "bg-[#EF4444]",
    "bg-[#06B6D4]",
    "bg-[#EC4899]",
    "bg-[#84CC16]",
    "bg-[#14B8A6]",
    "bg-[#6366F1]",
  ];

  // Group items into chunks of 3
  const groupedData = [];
  for (let i = 0; i < data.length; i += 3) {
    groupedData.push(data.slice(i, i + 3));
  }

  return (
    <div className="custom-container mx-auto">
      <div className="section_space_py bg-[rgba(116,69,255,0.04)] border border-[rgba(45,45,45,0.16)] rounded-[30px] px-[20px] md:px-[30px] lg:px-[50px] xl:px-[140px]">
        <div className="title_mb max-w-[600px] mx-auto">
          <h2 className="title-design text-center">
            {parseColorTextToJSX(title)}
          </h2>
        </div>

        <div className="space-y-[55px]">
          {groupedData.map((group, groupIndex) => (
            <div key={groupIndex} className="relative">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 border-b border-dashed border-[#1A2A4F] w-[68%] sm:block hidden" />
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-7.5 pt-2 sm:pt-[55px]">
                {group.map((step, index) => {
                  const realIndex = groupIndex * 3 + index;
                  const bgColor = bgColors[realIndex % bgColors.length];

                  return (
                    <div
                      key={realIndex}
                      className="relative flex flex-col items-center"
                    >
                      <div className="absolute top-[-55px] left-1/2 -translate-x-1/2 border-l border-dashed border-[#1A2A4F] h-[40px] w-px sm:block hidden" />
                      <div
                        className={`absolute top-[-15px] left-1/2 -translate-x-1/2 h-[10px] w-[10px] rounded-full sm:block hidden ${bgColor}`}
                      />
                      <div
                        className={`flex items-center justify-center w-[86px] h-[52px]
                        ${bgColor}
                        rounded-tl-[100px] rounded-br-[100px]
                        rounded-tr-[16px] rounded-bl-[16px] mb-5`}
                      >
                        <p className="text-white text-[22px] font-bold">
                          {realIndex + 1}
                        </p>
                      </div>
                      <div className="text-center">
                        <h4 className="text-[18px] font-bold text-user-text mb-2">
                          {step?.title}
                        </h4>
                        <p className="text-[14px] font-medium text-user-paragraph">
                          {step?.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowServiceWork;
